/*
 * form (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { forms } from "./form.schema"

/* Select */
export type Form = z.infer<typeof selectFormSchema>
export const selectFormSchema = createSelectSchema(forms)

/* Filters */
export type FormFilters = z.infer<typeof formFiltersSchema>
export const formFiltersSchema = z.object({
	id: z.string().optional(),
	slug: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createFormSchema = createInsertSchema(forms, {
	name: z.string().min(1).max(128),
	slug: z.string().min(1).max(64),
}).partial(globalCreateExclude)
export type CreateForm = z.infer<typeof createFormSchema>

/* Update */
export const updateFormSchema = createInsertSchema(forms)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateForm = z.infer<typeof updateFormSchema>
